/**
 * @generated SignedSource<<285334a55ecf6013426dccedf3d9bc4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponentTitle_componentModule$data = {
  readonly ctaLink: string | null;
  readonly ctaText: string | null;
  readonly eyebrow: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "HpSharedVideoComponentTitle_componentModule";
};
export type HpSharedVideoComponentTitle_componentModule$key = {
  readonly " $data"?: HpSharedVideoComponentTitle_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentTitle_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponentTitle_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eyebrow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaLink",
      "storageKey": null
    }
  ],
  "type": "VideoModule",
  "abstractKey": null
};

(node as any).hash = "ffc4f1cad10a76584a5769d1182a7cf5";

export default node;
